const advancedSearchLocale = {
  advancedSearch: {
    title: "Recherche avancée",
    selectFields: "Selectionnez les champs",
    addField: "Ajouter un champ",
  },
};

export type AdvancedSearchLocale = typeof advancedSearchLocale;

export default advancedSearchLocale;
